import { Chip } from "framework7-react";

import { FeelingEnum } from "@/generated/graphql/graphql";
import { useUserFeeling } from "@/hooks/useUserFeeling";
import feelingBad from "@/images/feeling-bad.png";
import feelingGood from "@/images/feeling-good.png";
import feelingUnset from "@/images/feeling-unset.png";

type FeelingChipProps = { feelingKey: FeelingEnum };

export function FeelingChip({ feelingKey }: FeelingChipProps) {
  const userFeeling = useUserFeeling(feelingKey);

  if (feelingKey === FeelingEnum.Good) {
    return (
      <Chip
        style={{ backgroundColor: "unset" }}
        text={userFeeling?.name}
      >
        <img
          alt={feelingKey}
          slot="media"
          src={feelingGood}
        />
      </Chip>
    );
  }

  if (feelingKey === FeelingEnum.Bad) {
    return (
      <Chip
        style={{ backgroundColor: "unset" }}
        text={userFeeling?.name}
      >
        <img
          alt={feelingKey}
          slot="media"
          src={feelingBad}
        />
      </Chip>
    );
  }

  if (feelingKey === FeelingEnum.Unset) {
    return (
      <Chip
        style={{ backgroundColor: "unset" }}
        text={userFeeling?.name}
      >
        <img
          alt={feelingKey}
          slot="media"
          src={feelingUnset}
        />
      </Chip>
    );
  }

  return null;
}
